import { ReactElement, useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Header from 'containers/Header';
import Table from 'containers/Table';
import { createStructuredSelector } from 'reselect';
import { makeSelectTokenAccessToken } from 'store/oauth/selectors';
import { Redirect, useHistory } from 'react-router-dom';
import { RouteTypes } from 'consts';
import './practice-list.scss';
import { RfUiBreadcrumbs, RfUiInput, RfUiModal } from 'renfe-components';
import { userProfile } from 'utils/profilesIndex';
import { makeSelectPerfilesUsuarioDatosPerfilesUsuarioSelected } from 'store/usuarios/selectors';
import {
  getTodayFinishDate,
  getTodayMinusOneYearStartDate,
} from 'utils/dates-validators';
import { useList } from 'hooks/list';
import {
  makeSelectPhotos,
  makeSelectPhotosCount,
} from 'store/photos/selectors';
import {
  getExcelPhotos,
  getPhotos,
  getPhotosCount,
  postRejectRequest,
  postValidRequest,
  setPhotos,
  setPhotosCount,
} from 'store/photos/actions';
import { parseDate } from 'utils/parsePractices';
import { ValidationPhotosFilter } from './ValidationPhotosFilter/ValidationPhotosFilter';
import { getTextEstadoFoto } from 'utils/stateUtils';
import { setLoading } from 'store/app/actions';

import {useCan} from 'hooks/visibilidadComponentes';

const selectors = createStructuredSelector({
  profileActive: makeSelectPerfilesUsuarioDatosPerfilesUsuarioSelected(),
  access_token: makeSelectTokenAccessToken(),
  photos: makeSelectPhotos(),
  photosCount: makeSelectPhotosCount(),
  profileSelected: makeSelectPerfilesUsuarioDatosPerfilesUsuarioSelected(),
} as any);

const links = [
  {
    label: 'Validar fotos',
    link: '#',
    textHelp: 'Validar fotos',
    active: true,
  },
];

const options =
  '[{"label": "Fecha estado de menor a mayor","value": {"order":"Fecha del último estado de la foto","ascDesc": "asc"},"active": "true"},{"label": "Fecha estado de mayor a menor","value": {"order":"Fecha del último estado de la foto","ascDesc": "desc"},"active": "false"}]';


const formatPhotoDate = (fechaProvisional: any): string =>
  fechaProvisional !== null && fechaProvisional !== 0
    ? parseDate(fechaProvisional)
    : 'Sin fecha';

const buildPhotoParsed = (item: any, index: number): any => ({
  table: [
    [
      { text: item.ID_ALUMNO },
      { text: item.ALUMNO_ACTIVO === 'S' ? 'Activo' : 'Inactivo' },
      { text: item.CONSENTIMIENTO === 'S' ? 'S' : 'N' },
      {
        text: formatPhotoDate(item.FECHA_PROVISIONAL),
      },
      {
        text: getTextEstadoFoto(item.ESTADO_FOTOGRAFIA),
      },
      {
        modalIcon: index + 1,
        ariaLabelIcon: 'Abrir modal',
        urlImg: item.FOTO_PERFIL ? item.FOTO_PERFIL : './images/user.png',
        estado: item.ESTADO_FOTOGRAFIA,
        observaciones: item.OBSERVACION,
        fecha: item.FECHA_PROVISIONAL,
        user: item.ID_ALUMNO,
        profile: item.PERFIL_ID,
      },
    ],
  ],
});

const buildPhotosParsed = (photosList: any[]): any[] => {
  if (photosList.some((item: any) => item.STATUS === 'KO')) {
    return [];
  }

  return photosList.map((item: any, index: number) =>
    buildPhotoParsed(item, index)
  );
};

const ValidationPhotos = (): ReactElement => {
  const { access_token, photos, profileActive, photosCount } = useSelector<
    any,
    any
  >(selectors);
  const [titleModal, settitleModal] = useState<string>('');
  const [modalTypePhoto, setModalTypePhoto] = useState<string>('');
  const [modalTypeTextArea, setModalTypeTextArea] = useState<string>('');
  const [image, setImage] = useState<string>('');
  const [dateState, setDateState] = useState<string>('');
  const [referenceClick, setReferenceClick] = useState<string>('');
  const [observaciones, setObservaciones] = useState<string>('');
  const [user, setUser] = useState<string>('');
  const [perfilUser, setPerfilUser] = useState<string>('');

  const dispatch = useDispatch();
  const history = useHistory();
  const canSee = useCan();
  const initFilter = {
    alumno: '',
    ascDesc: '',
    elemFinal: 10,
    elemFin: 10,
    elemInicio: 0,
    estado: 'PV',
    fechaFin: getTodayFinishDate(),
    fechaIni: getTodayMinusOneYearStartDate(),
    orden: '',
  };

  const {
    filterRef,
    data,
    setData,
    headers,
    setHeaders,
    handleFilterTable,
    handleFilterChange,
  } = useList(
    { ...initFilter },
    [],
    {
      action: (filter) => dispatch(getPhotos(filter)),
      headerToAPIMap: {
        'Fecha del último estado de la foto': 'FECHA_ESTADO',
      },
    },
    (filter) => {
      setData([]);
      dispatch(setPhotosCount(0));
      dispatch(getPhotos(filter));
      dispatch(getPhotosCount(filter));
    },
    async ()=>{
      dispatch(setLoading(true));
      await new Promise(resolve => setTimeout(resolve, 90));
      dispatch(setLoading(false));
   }
  );

  useEffect(() => {
    if (!profileActive) {
      return;
    }
    const headers: any[] = [
      {
        text: 'Alumno',
      },
      { text: 'Estado Alumno' },
      { text: 'Consentimiento' },
      {
        text: 'Fecha del último estado de la foto',
        orderBy: true,
        ariaLabelIcon: 'Icono de ordenar',
      },
      {
        text: 'Estado foto',
      },
      {
        text: 'Ver foto',
        hideResponsive: true,
      },
    ];

    setHeaders(headers);
  }, [profileActive]);

  useEffect(() => {
    if (!profileActive) {
      return;
    }

    setData(buildPhotosParsed(photos) as any);
  }, [photos]);

  const redirect = (e: any) => {
    history.push(e.detail);
  };

  useEffect(() => {
    if (profileActive) {
      if (profileActive?.ID_PERFIL !== userProfile.administrador && profileActive?.ID_PERFIL !== userProfile.supervisor && profileActive?.ID_PERFIL !== userProfile.visualizador) {
        history.push(RouteTypes.HOME);
      }
      dispatch(getPhotos(filterRef.current));
      dispatch(getPhotosCount(filterRef.current));
    }
  }, [profileActive]);

  if (!access_token) {
    return <Redirect to={RouteTypes.LOGIN} push />;
  }

  const handleExportExcel = () => {
    const newHeaders = [
      {
        text: 'Alumno',
      },
      {
        text: 'Estado Alumno',
      },
      {
        text: 'Consentimiento',
      },
      {
        text: 'Fecha del último estado de la foto',
      },
      {
        text: 'Estado foto',
      },
    ];
    dispatch(
      getExcelPhotos({
        filter: { ...filterRef.current },
        excelConfig: {
          literals: newHeaders,
          profile: profileActive,
        },
      })
    );
  };

  const handleShoose = (e): void => {
    setUser(e.user);
    setDateState(e.fecha);
    setPerfilUser(e.profile);
    if (e.estado === 'PV') {
      settitleModal('¿Quieres validar o rechazar esta imagen?');
      setImage(e.urlImg);
      setObservaciones(e.observaciones);
      setReferenceClick(e.modalIcon);
      setModalTypePhoto('photo');
    } else if (e.estado === 'RZ') {
      setModalTypeTextArea('');
      setModalTypePhoto('alert');
      settitleModal(`Razón del rechazo: ${e.observaciones}`);
      setObservaciones(e.observaciones);
      setImage('');
      setReferenceClick(e.modalIcon);
    } else {
      setModalTypeTextArea('');
      settitleModal('Imagen validada');
      setImage(e.urlImg);
      setReferenceClick(e.modalIcon);
      setModalTypePhoto('photo-alert');
    }
  };

  const handleTextArea = (e) => {
    setObservaciones(e.detail);
  };

  const closePhotoModal = () => {
    setModalTypePhoto('');
  };

  const closeTextAreaModal = () => {
    settitleModal('¿Quieres validar o rechazar esta imagen?');
    setModalTypeTextArea('');
  };

  const confirmModalValid = (valid) => {
    if(canSee.canSeePerfil){
      valid ? validSelection() : rejectSelection();
    }
  };

  const rejectModalClose = (type) => {
    if(canSee.canSeePerfil){
      if (type) {
        settitleModal('Introduce la razón del rechazo');
        setModalTypePhoto('');
        setModalTypeTextArea('confirm-textArea');
      } else {
        setModalTypeTextArea('');
        setModalTypePhoto('photo');
      }
    }
  };

  const validSelection = () => {
    const validate = {
      fecha: dateState,
      user: user,
      profile: perfilUser,
    };
    const params = {
      validate: validate,
      filter: filterRef.current,
    };
    setData([]);
    dispatch(postValidRequest(params));

  };

  const rejectSelection = () => {
    const filter = {
      observacion: observaciones,
      fecha: dateState,
      user: user,
      profile: perfilUser,
    };
    dispatch(postRejectRequest(filter));
    // Empty data and fill it again to reset selectors selected value
    dispatch(setPhotos([]));

    setTimeout(() => {
      // force table re-render because selects don't reset
      dispatch(getPhotos(filterRef.current));
      dispatch(getPhotosCount(filterRef.current));
    });
    dispatch(setLoading(false));
    setModalTypePhoto('');
    setModalTypeTextArea('');
    setObservaciones('');
  };


  return (
    <>
      <Header />
      <div className="rf-layout-table rf-practice-list">
        <RfUiBreadcrumbs
          links={JSON.stringify(links)}
          onEventChange={(e: any) => {
            history.push(e.detail);
          }}
        ></RfUiBreadcrumbs>
        <h1 className="rf-title rf-title--simple">
          Validar fotografía de perfil
        </h1>

        <ValidationPhotosFilter handleSubmit={handleFilterChange} />
        <Table
          redirect={(e: any) => {
            redirect(e);
          }}
          list={false}
          headers={headers}
          data={data}
          dataCount={photosCount}
          handleFilter={handleFilterTable}
          hideAudit={true}
          showButtonDetail={true}
          orderMobile={true}
          itemsOnLeft={2}
          orderOptions={options}
          handleExportExcel={handleExportExcel}
          handleShoose={handleShoose}
        />

        <RfUiModal
          title-modal={titleModal}
          id-modal="modal-validation"
          reference-click={referenceClick}
          modal-type={modalTypePhoto}
          urlImg={image}
          modalConfirmText="Validar"
          modalRejectText="Rechazar"
          onModalClose={(e: any) => {
            closePhotoModal();
          }}
          onConfirm={
            canSee.canSeePerfil ? (e: any) => confirmModalValid(true) : undefined
          }
           onReject={
            canSee.canSeePerfil ? (e: any) => rejectModalClose(true) : undefined
          }
        ></RfUiModal>


        <RfUiModal
          requiredSlot={
            observaciones !== '' && observaciones !== null ? false : true
          }
          title-modal={titleModal}
          id-modal="modal-validation"
          reference-click={referenceClick}
          modal-type={modalTypeTextArea}
          urlImg={image}
          slotContent={true}
          modalConfirmText="Rechazar"
          modalRejectText="Cancelar"
          onModalClose={(e: any) => {
            closeTextAreaModal();
          }}

          onConfirm={(e: any) => {
            confirmModalValid(false);
          }}
          onReject={(e: any) => {
            rejectModalClose(false);
          }}
        >
          <div slot="content">
            <RfUiInput
              label=""
              className="rf-input"
              error=""
              disabled={false}
              value={observaciones}
              onValueChanges={(e) => handleTextArea(e)}
            ></RfUiInput>
          </div>
        </RfUiModal>
      </div>
    </>
  );
};

export default ValidationPhotos;
